import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NRTQuestionTrueOrFalse from "./_components/TrueOfFalse"
import NRTQuestionContainer from "./_components/QuestionContainer"
import NRTQuestionMultiple from "./_components/Multiple"
import NRTQuestionText from "./_components/Text"
import MCLoading from "../../../_minha-central/Loading"
import MCLoadingOverlay from "../../../_minha-central/LoadingOverlay"
import './style.css'
import _ from "lodash"
import ButtonWithChevron from "../../../_minha-central/ButtonWithChevron"
import NRTFormStateManager from "../../../_common/_form/FormStateManager"
import {QuestionTypeEnum} from "../../../../enums/QuestionTypeEnum"
import EadRequests from "../../../../requests/ead-requests"


class NRTQuestions extends Component {

    questionEls = {
        1: NRTQuestionMultiple, //ONE_ANSWER
        2: NRTQuestionTrueOrFalse, //TRUE OR FALSE
        3: NRTQuestionText, //OPEN_ANSWER
    }

    state = {}


    async componentDidMount() {
        this.init()
    }


    init() {

        if (!this.props.context.eadAnswers)
            this.props.context.set({eadAnswers: {}})


        this.setState({
            questions: null,
            formValue: null,
            maxTries: null,
            form: {},
            hasAnswers: false,
            submitLoading: false
        }, async () => {
            await this.setDataToBuildForm()
        })
    }


    componentDidUpdate(prevProps, prevState) {
        if (_.get(prevProps, 'form.code') !== _.get(this.props, 'form.code'))
            this.init()
    }


    /** Define dados para montagem do questionario (distingue formualario respondido / nao-respondido). */
    async setDataToBuildForm() {

        const formAnswers = await this.searchFormAnswers()

        if (!_.isEmpty(formAnswers)) {
            await this.setDataToBuildAnsweredForm(formAnswers)
        } else {
            this.setDataToBuildUnansweredForm()
        }
    }


    /** Busca & retorna respostas para questoes do formulario atual (se houver). */
    async searchFormAnswers() {

        const {form, eadUser} = this.props

        const searchParams = {
            frmCode: form.code,
            usrCode: eadUser.code,
        }

        const reqResult = await EadRequests.searchUserAnswers(searchParams)

        return reqResult.useranswer || null
    }


    /** Define dados para montagem do questionario que ainda nao foi respondido. */
    setDataToBuildUnansweredForm() {

        const {
            numQuestions,
            maxTries,
            random,
            questionDTOs
        } = this.props.form

        // Define lista de questoes
        let questions = []

        if (random) {

            const alreadyIn = []

            for (let i = 0; i < numQuestions; i++) {

                let index = Math.floor(Math.random() * numQuestions)

                while (alreadyIn.includes(index)) {
                    index = Math.floor(Math.random() * numQuestions)
                }

                questions.push(questionDTOs[index])
                alreadyIn.push(index)
            }


        } else {

            questions = questionDTOs.sort((a, b) => a.order < b.order ? -1 : 1)
        }

        let currentTry = null

        if (maxTries) {
            const tries = this.state.tries || 0
            currentTry = tries + 1
        }

        // Define valor do form
        const formValue = questions
            .map(question => question.value)
            .reduce((total, next) => (total + next), 0)

        // Atualiza state
        this.setState({
            questions: null,
            formValue: null,
            maxTries: null,
            hasAnswers: false
        }, () => {
            this.setState({questions, formValue, maxTries, hasAnswers: false, currentTry})
        })
    }


    groupBy(list, keyGetter) {
        const map = new Map()
        list.forEach((item) => {
            const key = keyGetter(item)
            const collection = map.get(key)
            if (!collection) {
                map.set(key, [item])
            } else {
                collection.push(item)
            }
        })
        return map
    }


    async setDataToBuildAnsweredForm(formAnswers) {
        const {form, eadUser} = this.props

        const groupedByQuestionCode = this.groupBy(formAnswers, ans => ans.questionDTO.code)
        const questions = _.uniqBy(formAnswers.sort((a, b) => a.date - b.date).map(ans => ans.questionDTO), que => que.code)

        const questionsWithAnswers = []
        groupedByQuestionCode.forEach((values, key) => {
            const question = {...questions.filter(que => que.code === key)[0]}
            if (question.type === 1) {
                question.answer = values[0].optionDTO
            } else if (question.type === 2) {
                // console.log(values.map(obj => ({id: obj.optionDTO.code, value: obj.answer})), "AHDHADHUDHUI")
                question.answer = values.map(obj => ({id: obj.optionDTO.code, value: obj.answer}))
            } else {
                question.answer = values[0].answer
            }

            questionsWithAnswers.push(question)
        })

        const formValue = questions.map(que => que.value).reduce((total, next) => total + next)

        let tries = null
        if (form.maxTries) {

            const filter = {
                frmCode: form.code,
                usrCode: eadUser.code,
            }
            const result = await EadRequests.searchUserForms(filter)

            tries = result.userform.length
        }


        this.setState({
            questions: questionsWithAnswers,
            formValue,
            hasAnswers: true,
            maxTries: form.maxTries,
            tries,
        })
    }


    /** Envia respostas do questionario para api. */
    submitForm = async () => {
        this.setState({
            submitLoading: true
        })

        const formValues = this.state.form.values

        const validateValues = Object.values(formValues).includes(null)
        if (validateValues || !this.state.form.valid) {
            return this.props.context.set({
                toastMessage: {
                    type: 'warning',
                    content: 'Você possui questões em branco, verifique novamente o questionário'
                }
            }, () => {
                this.setState({
                    submitLoading: false
                })
            })
        }

        /** Monta & retorna lista de respostas p/ questoes que NAO sao de V || F. */
        const getNotTrueOfFalseAnswersList = (questionCodes, formValues) => {

            const notTrueOrFalseAnswersList = []

            questionCodes.forEach(questionCode => {

                questionCode = parseInt(questionCode)
                const formFieldValue = formValues[questionCode]
                const question = this.state.questions.filter(question => (question.code === questionCode))[0]
                // console.log(/*"questionCode: ", questionCode, "step: ", */question/*, "formfield: ", formFieldValue*/)

                if (question.type !== QuestionTypeEnum.TRUE_OR_FALSE) {

                    const returnObj = {
                        formDTO: form,
                        userDTO: eadUser,
                        questionDTO: question,
                        answer: formFieldValue
                    }

                    if (question.type == QuestionTypeEnum.ONE_ANSWER) {
                        returnObj.optionDTO = question.optionDTOs.filter(option => (option.code === formFieldValue))[0]
                    }

                    notTrueOrFalseAnswersList.push(returnObj)
                }
            })

            return notTrueOrFalseAnswersList
        }

        /** Monta & retorna lista de respostas p/ questoes de V || F. */
        const getTrueOrFalseAnswersList = (questionCodes, formValues) => {

            const trueOrFalseAnswersList = []

            questionCodes.forEach(questionCode => {

                questionCode = parseInt(questionCode)
                const formFieldValue = formValues[questionCode]
                const question = this.state.questions.filter(question => (question.code === questionCode))[0]
                // console.log(/*"questionCode: ", questionCode, "step: ", */question/*, "formfield: ", formFieldValue*/)

                if (question.type === QuestionTypeEnum.TRUE_OR_FALSE) {

                    question.optionDTOs.forEach(option => {

                        trueOrFalseAnswersList.push({
                            formDTO: form,
                            userDTO: eadUser,
                            questionDTO: question,
                            optionDTO: option,
                            answer: formFieldValue[option.code]
                        })
                    })
                }
            })

            return trueOrFalseAnswersList
        }


        // Prepara lista de respostas
        const {form, eadUser} = this.props
        const questionCodes = Object.keys(formValues)

        const notTrueOrFalseAnswers = getNotTrueOfFalseAnswersList(questionCodes, formValues)
        const trueOrFalseAnswers = getTrueOrFalseAnswersList(questionCodes, formValues)
        const userAnswerDTOList = notTrueOrFalseAnswers.concat(trueOrFalseAnswers)

        // Envia requisicao
        const reqResult = await EadRequests.saveUserAnswers(userAnswerDTOList)



        if (reqResult.success) {
            const res = await EadRequests.consolidateFormData({
                frmCode: form.code,
                usrCode: eadUser.code
            })

            this.props.onQuestionAnswersSent()

            this.props.context.set({
                eadAnswers: {
                    ...this.props.context.eadAnswers,
                    [form.code]: {
                        grade: res.grade,
                        best: res.best,
                    }
                }
            })


            const elemDOM = document.querySelector('.master')
            elemDOM.scrollTop = 0;

            this.props.context.set({
                toastMessage: {
                    type: 'success',
                    content: "Questionário enviado com sucesso!"
                }
            })
        }
        this.setState({
            hasAnswers: true,
            tries: (this.state.tries || 0) + 1,
            submitLoading: false
        })
    }

    onFormStateChange = (form) => {
        this.setState({form})
    }


    /** Monta & retorna HTML das questoes do questionario. */
    getFormQuestionListHtml(questions, hasAnswers) {

        return (
            questions.map((question, index) => {


                const QuestionEl = this.questionEls[question.type]

                let questionTitle = `${index + 1}) ${question.title} `

                if (!!question.value) {
                    questionTitle += `(${question.value.toFixed(2)})`
                }

                return (
                    <NRTQuestionContainer
                        key={'question-' + index}
                        title={questionTitle}
                    >
                        <div
                            style={{padding: '0 1rem', marginBottom: '1rem'}}
                            dangerouslySetInnerHTML={{__html: question.description}}
                        />

                        <QuestionEl {...question} disabled={hasAnswers}/>
                    </NRTQuestionContainer>
                )
            })
        )
    }


    redoForm = () => {
        this.setDataToBuildUnansweredForm()
    }


    render() {

        const {questions, formValue, hasAnswers, tries, maxTries, currentTry, submitLoading} = this.state
        if (!questions) return (<MCLoading/>)
      
        return (

            <NRTFormStateManager
                ref={form => (this.form = form)}
                onStateChange={this.onFormStateChange}
            >
                <div className={'nrt-ead-questions' + (hasAnswers ? ' disabled' : '')}>
                    {submitLoading && <MCLoadingOverlay show={true}/>}
                    {
                        !hasAnswers && maxTries &&
                        <span className={"form-try"}> Tentativa {currentTry}/{maxTries} </span>
                    }

                    {
                        !!formValue &&
                        <span className={'form-value'}> Valor: {formValue.toFixed(2)} </span>
                    }

                    {this.getFormQuestionListHtml(questions, hasAnswers)}

                    <ButtonWithChevron
                        buttonLabel={'Enviar'}
                        onClick={this.submitForm}
                        disabled={hasAnswers || false}
                        style={{margin: "0 auto"}}
                    />

                    <ButtonWithChevron
                        buttonLabel={'Refazer Teste ' + (maxTries ? `(${maxTries - tries} tentativas restantes)` : "")}
                        secondary
                        onClick={this.redoForm}
                        disabled={!hasAnswers || (maxTries && currentTry >= maxTries)}
                        style={{margin: "2rem auto"}}
                    />
                </div>
            </NRTFormStateManager>
        )
    }
}


NRTQuestions.propTypes = {
    form: PropTypes.object.isRequired,
    eadUser: PropTypes.object.isRequired ,
    onQuestionAnswersSent :  PropTypes.func.isRequired
}

NRTQuestions.defaultProps = {}


export default NRTQuestions



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/Questions/index.js